module.exports = __webpack_public_path__ + "img/leadSpamByAdvertiser.e1d99f9b.svg";